'use strict';

var arrayFill = require('../internals/array-fill');

var ArrayBufferViewCore = require('../internals/array-buffer-view-core');

var aTypedArray = ArrayBufferViewCore.aTypedArray; // `%TypedArray%.prototype.fill` method
// https://tc39.github.io/ecma262/#sec-%typedarray%.prototype.fill
// eslint-disable-next-line no-unused-vars

ArrayBufferViewCore.exportProto('fill', function fill(value
/* , start, end */
) {
  return arrayFill.apply(aTypedArray(this), arguments);
});